export type NamedUser = {
  firstName?: string | null;
  lastName?: string | null;
  userName?: string | null;
};

export function getDisplayName(user: NamedUser | null | undefined): string {
  if (!user) return '';
  const full = [user.firstName, user.lastName].filter(Boolean).join(' ').trim();
  return full || user.userName || '';
}
